import React from 'react';
import { ScoreCardSignal } from '../types/stockAdvice';
import { formatLseNumericDisplay, isUnavailableDisplayValue } from './stockAdviceFormatting';

interface CatalystCardProps {
  nextEarningsDate?: string | null;
  lastEarningsDate?: string | null;
  earningsTrendSummary?: string | null;
  catalysts: ScoreCardSignal[];
  exchange: string;
}

export const CatalystCard: React.FC<CatalystCardProps> = ({ nextEarningsDate, lastEarningsDate, earningsTrendSummary, catalysts, exchange }) => {
  const nextText = nextEarningsDate && !isUnavailableDisplayValue(nextEarningsDate) ? nextEarningsDate : 'Earnings calendar unavailable';
  const lastText = lastEarningsDate && !isUnavailableDisplayValue(lastEarningsDate) ? lastEarningsDate : 'Earnings calendar unavailable';
  const trendText = earningsTrendSummary && !isUnavailableDisplayValue(earningsTrendSummary) ? earningsTrendSummary : 'Provider coverage limited';

  const cleanedCatalysts = catalysts
    .filter((item) => item && item.label)
    .map((item) => ({ ...item, value: formatLseNumericDisplay(item.value, exchange) }))
    .filter((item, index, arr) => arr.findIndex((x) => `${x.label}:${x.value}` === `${item.label}:${item.value}`) === index)
    .filter((item) => !isUnavailableDisplayValue(item.value))
    .slice(0, 3);

  return (
    <section className="rounded-3xl border border-white/10 bg-[#151521] p-4 space-y-3">
      <h4 className="text-sm font-semibold text-white">Catalyst & Earnings</h4>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-xs">
        <p className="text-slate-300">Next: <span className="text-slate-400">{nextText}</span></p>
        <p className="text-slate-300">Last: <span className="text-slate-400">{lastText}</span></p>
        <p className="text-slate-300">Trend: <span className="text-slate-400">{trendText}</span></p>
      </div>
      <ul className="space-y-1 text-xs text-slate-300">
        {cleanedCatalysts.length
          ? cleanedCatalysts.map((item) => <li key={item.label} className="break-words">• {item.label}: {item.value}</li>)
          : <li>• Provider coverage limited.</li>}
      </ul>
    </section>
  );
};
